import { createFileRoute } from "@tanstack/react-router";
import NavbarWebsite from "../components/NavbarWebsite";
import NavbarFooter from "../components/Footer";
import { JSX } from "react";

export const Route = createFileRoute("/privacy-policy")({
  component: RouteComponent,
});

function RouteComponent() {
  const sections = [
    "What data do we collect?",
    "How do we collect your data?",
    "How will we use your data?",
    "How do we store your data?",
    "Marketing",
    "What are your data protection rights?",
    "What are cookies?",
    "How do we use cookies?",
    "What types of cookies do we use?",
    "How to manage your cookies",
    "Privacy policies of other websites",
    "Changes to our privacy policy",
    "How to contact us",
    "How to contact the appropriate authorities",
  ];

  return (
    <>
      <div className="min-h-screen bg-white text-gray-800">
        <NavbarWebsite />
        <div className=" max-w-3xl mx-auto mt-20">
          <p className="text-4xl font-extrabold text-center mb-4 pt-9 ">
            Privacy Policy{" "}
          </p>
          <p className="text-l font-normal text-center mb-4 pb-2">
            EFFECTIVE DATE: Juli 8, 2025
          </p>
        </div>

        <div>
          {/* Table of Contents */}
          <div className="max-w-3xl mx-auto px-4 pb-20">
            <div className="mb-10 mx-30 text-left">
              <h2 className="text-xl font-semibold mb-4">Topics:</h2>
              <ul className="list-inside space-y-2 text-blue-600">
                {sections.map((title) => (
                  <li key={title}>
                    <a
                      href={`#${title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                      className="hover:underline"
                    >
                      {title}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Content Sections */}
            <div className="space-y-10 text-left">
              <Section
                id="what-data-do-we-collect"
                title="What data do we collect?"
              >
                <p>Our Company collects the following data:</p>
                <ul className="list-disc list-inside ml-4">
                  <li>
                    Personal identification information (Name, email address,
                    phone number, etc.)
                  </li>
                  <li>[Add any other data your company collects]</li>
                </ul>
              </Section>

              <Section
                id="how-do-we-collect-your-data"
                title="How do we collect your data?"
              >
                <p>
                  You directly provide Our Company with most of the data we
                  collect. We collect and process data when you:
                </p>
                <ul className="list-disc list-inside ml-4">
                  <li>Register online or place an order.</li>
                  <li>Complete surveys or provide feedback.</li>
                  <li>Use our website through cookies.</li>
                  <li>[Other methods]</li>
                </ul>
              </Section>

              <Section
                id="how-will-we-use-your-data"
                title="How will we use your data?"
              >
                <p>We use your data to:</p>
                <ul className="list-disc list-inside ml-4">
                  <li>Process orders and manage accounts.</li>
                  <li>Email special offers.</li>
                  <li>[Other uses]</li>
                </ul>
              </Section>

              <Section
                id="how-do-we-store-your-data"
                title="How do we store your data?"
              >
                <p>
                  We store data securely at [location]. We retain data for
                  [time], then delete it using [method].
                </p>
              </Section>

              <Section id="marketing" title="Marketing">
                <p>We may send you product info from us or partners like:</p>
                <ul className="list-disc list-inside ml-4">
                  <li>[List partner companies]</li>
                </ul>
                <p>
                  You can opt out anytime. Click{" "}
                  <a href="#" className="text-blue-600 underline">
                    here
                  </a>{" "}
                  to unsubscribe.
                </p>
              </Section>

              <Section
                id="what-are-your-data-protection-rights"
                title="What are your data protection rights?"
              >
                <p>You have the right to:</p>
                <ul className="list-disc list-inside ml-4">
                  <li>Access your data</li>
                  <li>Request corrections</li>
                  <li>Request deletion</li>
                  <li>Restrict or object to processing</li>
                  <li>Request data portability</li>
                </ul>
              </Section>

              <Section id="what-are-cookies" title="What are cookies?">
                <p>
                  Cookies are small text files used to collect visitor behavior
                  info. Learn more at{" "}
                  <a
                    className="text-blue-600 underline"
                    href="https://allaboutcookies.org"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    allaboutcookies.org
                  </a>
                  .
                </p>
              </Section>

              <Section
                id="how-do-we-use-cookies"
                title="How do we use cookies?"
              >
                <ul className="list-disc list-inside ml-4">
                  <li>Keep you signed in</li>
                  <li>Understand website usage</li>
                  <li>[Other uses]</li>
                </ul>
              </Section>

              <Section
                id="what-types-of-cookies-do-we-use"
                title="What types of cookies do we use?"
              >
                <ul className="list-disc list-inside ml-4">
                  <li>
                    <strong>Functionality:</strong> Remembers preferences.
                  </li>
                  <li>
                    <strong>Advertising:</strong> Tracks usage for targeted ads.
                  </li>
                  <li>[Other types]</li>
                </ul>
              </Section>

              <Section
                id="how-to-manage-your-cookies"
                title="How to manage your cookies"
              >
                <p>
                  You can set browsers to refuse cookies. This may impact
                  functionality.
                </p>
              </Section>

              <Section
                id="privacy-policies-of-other-websites"
                title="Privacy policies of other websites"
              >
                <p>
                  Our privacy policy only applies to our website. External sites
                  have their own policies.
                </p>
              </Section>

              <Section
                id="changes-to-our-privacy-policy"
                title="Changes to our privacy policy"
              >
                <p>
                  We regularly review this policy. Last updated on January 9,
                  2019.
                </p>
              </Section>

              <Section id="how-to-contact-us" title="How to contact us">
                <p>For questions or data requests, contact us via:</p>
                <ul className="list-inside ml-4">
                  <li>Email: [your email]</li>
                  <li>Phone: [your phone]</li>
                  <li>Address: [your address]</li>
                </ul>
              </Section>

              <Section
                id="how-to-contact-the-appropriate-authorities"
                title="How to contact the appropriate authorities"
              >
                <p>
                  If you have unresolved concerns, contact the Information
                  Commissioner’s Office:
                </p>
                <ul className="list-inside ml-4">
                  <li>Email: [authority email]</li>
                  <li>Address: [authority address]</li>
                </ul>
              </Section>
            </div>
          </div>
        </div>
        <NavbarFooter />
      </div>
    </>
  );
}

function Section(props: {
  id: string;
  title: string;
  children: JSX.Element | JSX.Element[];
}) {
  const { id, title, children } = props;

  return (
    <section id={id} className="scroll-mt-24">
      <h2 className="text-2xl font-bold mb-2">{title}</h2>
      <div className="text-base space-y-2">{children}</div>
    </section>
  );
}
